import React from 'react';

import RouteIfRights from 'pages/router/RouteIfRights';
import VendorReturns from '.';

export const paths = {
  view: '/inventory/vendor-returns/:id',
};

export default [
  <RouteIfRights
    exact
    path={paths.view}
    component={VendorReturns}
    key={paths.view}
    rights="vendor_returns"
  />,
];
